export enum WindowNames {
  PERSISTENT = "hornet-persistent",
  LAUNCHER = "hornet-launcher",
}
